import { StyleRules } from '@material-ui/core/styles';
import { ListSubheaderClassKey } from '@material-ui/core/ListSubheader';

import { core as theme } from '../styles/core';

export const MuiListSubheader: Partial<StyleRules<ListSubheaderClassKey>> = {
  root: {
    lineHeight: 1.6,
    color: theme.palette.grey[500],
  },
};
